import { render, staticRenderFns } from "./OldOrderPicker.vue?vue&type=template&id=440e5ec4&scoped=true"
import script from "./OldOrderPicker.vue?vue&type=script&lang=js"
export * from "./OldOrderPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e5ec4",
  null
  
)

export default component.exports